import React, { useState, useEffect } from 'react';
import { ProductCard } from '../ProductRecommendTab/index';
import Summary from '@/components/Summary';
import { ScrollArea } from '@/components/ui/scroll-area';
import { SkeletonDashboard } from '@/components/loading/Skeleton';

const ProductRecommend: React.FC<any> = ({ totalData, loading }) => {
  const [products, setProducts] = useState(totalData.product_info || []);
  const [isDataChanging, setIsDataChanging] = useState(false);

  // 模拟数据变化
  useEffect(() => {
    setProducts(totalData.product_info || []);
  }, [totalData]);

  const handleSend = (productName: string) => {
    console.log(`发送产品: ${productName}`);
    // 这里可以添加发送逻辑
  };

  if (loading) {
    return (
      <div className="absolute left-0 top-0 z-[111111] flex h-full w-full items-center justify-center">
        <SkeletonDashboard className="absolute left-0 top-0 w-full px-0" />
      </div>
    );
  }

  return (
    <ScrollArea className="scroll-area-block h-full w-full">
      <div className="space-y-4">
        {/* 产品卡片列表 */}
        <div className="space-y-3">
          {products.map((product, index) => (
            <div
              key={index}
              // className={`transition-all duration-1000 ${
              //   isDataChanging ? 'opacity-80 scale-[0.98]' : 'opacity-100 scale-100'
              // }`}
            >
              <ProductCard product={product} onSend={() => handleSend(product.产品名称)} />
            </div>
          ))}
        </div>
        <Summary isShowSuggestions={false} title="综合投资建议" content={totalData.综合投资建议} />
      </div>
    </ScrollArea>
  );
};

export default ProductRecommend;
